import React from 'react';
import { useTranslation } from 'react-i18next';
import { Plus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { TableCell, TableRow } from '@/components/ui/table';
import { cn } from '@/lib/utils';
import UnitActionsMenu, { type UnitActionsMenuProps } from './UnitActionsMenu';
import { UNIT_BODY_COLUMNS, stickyCol0, stickyCol1, unitCell } from './itemTableLayout';

const VerificationUnitEmptyRow: React.FC<UnitActionsMenuProps> = ({
  unit,
  onAddItem,
  onEditUnit,
  onDeleteUnit,
}) => {
  const { t } = useTranslation();

  return (
    <TableRow>
      <TableCell className={cn(unitCell, stickyCol0, 'revy-figure align-middle text-center')}>
        {unit.unitNumber}
      </TableCell>
      <TableCell className={cn(unitCell, stickyCol1, 'align-middle')}>
        <div className="flex items-center gap-0.5">
          <p className="revy-cjk text-xs font-bold leading-[1.5]">{unit.unitName}</p>
          <div className="ml-auto">
            <UnitActionsMenu
              unit={unit}
              onAddItem={onAddItem}
              onEditUnit={onEditUnit}
              onDeleteUnit={onDeleteUnit}
            />
          </div>
        </div>
      </TableCell>
      <TableCell colSpan={UNIT_BODY_COLUMNS} className="border-b border-b-[#e0e0e0] text-center">
        {onAddItem && (
          <Button variant="outline" size="sm" onClick={() => onAddItem(unit.id)}>
            <Plus strokeWidth={1.8} />
            {t('verification.addItem')}
          </Button>
        )}
      </TableCell>
    </TableRow>
  );
};

export default VerificationUnitEmptyRow;
